import { render, staticRenderFns } from "./GiftProductInfoForm.vue?vue&type=template&id=70b80cce&"
import script from "./GiftProductInfoForm.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b80cce')) {
      api.createRecord('70b80cce', component.options)
    } else {
      api.reload('70b80cce', component.options)
    }
    module.hot.accept("./GiftProductInfoForm.vue?vue&type=template&id=70b80cce&", function () {
      api.rerender('70b80cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftProductInfoForm.vue"
export default component.exports